import './styles.css'
import { useTranslation } from 'react-i18next'

const AssetListHeader = () => {
  const { t } = useTranslation('wallet', { keyPrefix: 'assetList.header' })

  return (
    <div className='comp-asset-header comp-asset-table-row'>
      <div className='comp-asset-header-item'>{t('asset')}</div>
      <div className='comp-asset-header-item'>{t('portfolio')}</div>
      <div className='comp-asset-header-item'>{t('available')}</div>
      <div className='comp-asset-header-item'>{t('locked')}</div>
      <div className='comp-asset-header-item'>{t('amount')}</div>
      <div className='comp-asset-header-actions'>{t('actions')}</div>
    </div>
  )
}

export default AssetListHeader
